import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full mx-auto" }
const _hoisted_2 = { class: "mx-4 overflow-hidden bg-white shadow-xl rounded-2xl p-4 -mt-16 relative z-10 border border-slate-100" }
const _hoisted_3 = { class: "flex flex-wrap items-center -mx-4" }
const _hoisted_4 = { class: "w-auto px-4" }
const _hoisted_5 = { class: "relative w-20 h-20 sm:w-24 sm:h-24" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "w-auto px-4 my-auto" }
const _hoisted_8 = { class: "h-full flex flex-col justify-center" }
const _hoisted_9 = { class: "text-xl font-bold mb-1 text-slate-800" }
const _hoisted_10 = { class: "mb-0 text-xs text-slate-500" }
const _hoisted_11 = { class: "mx-auto mt-4 px-4 w-full md:w-1/2 lg:w-1/3 sm:my-auto sm:ml-auto sm:mr-0" }
const _hoisted_12 = { class: "relative w-full text-right" }
const _hoisted_13 = { class: "py-4 w-full mx-auto px-4" }
const _hoisted_14 = { class: "mt-3 flex flex-wrap -mx-4" }
const _hoisted_15 = { class: "bg-white shadow-lg rounded-2xl flex flex-col h-full border border-slate-100" }
const _hoisted_16 = { class: "p-4 grid grid-cols-3 gap-2 text-xs md:text-sm" }
const _hoisted_17 = { class: "text-slate-500" }
const _hoisted_18 = { class: "text-dark-gradient col-span-2" }
const _hoisted_19 = { class: "text-slate-500" }
const _hoisted_20 = { class: "text-dark-gradient col-span-2" }
const _hoisted_21 = { class: "text-slate-500" }
const _hoisted_22 = { class: "text-dark-gradient col-span-2" }
const _hoisted_23 = { class: "text-slate-500" }
const _hoisted_24 = { class: "text-dark-gradient col-span-2" }
const _hoisted_25 = { class: "text-slate-500" }
const _hoisted_26 = { class: "text-dark-gradient col-span-2" }
const _hoisted_27 = { class: "text-slate-500" }
const _hoisted_28 = { class: "text-dark-gradient col-span-2" }
const _hoisted_29 = { class: "col-span-3" }
const _hoisted_30 = {
  key: 0,
  class: "w-full lg:w-1/2 px-4 mb-6"
}
const _hoisted_31 = { class: "bg-white shadow-lg rounded-2xl flex flex-col h-full border border-slate-100" }
const _hoisted_32 = { class: "flex flex-wrap items-center -mx-4 p-4 pb-0" }
const _hoisted_33 = { class: "w-auto px-4" }
const _hoisted_34 = { class: "relative w-20 h-20 sm:w-24 sm:h-24" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "w-auto my-auto" }
const _hoisted_37 = { class: "h-full flex flex-col justify-center" }
const _hoisted_38 = { class: "text-xl font-bold mb-1 text-slate-800" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "p-4 grid grid-cols-3 gap-2 text-xs md:text-sm" }
const _hoisted_41 = { class: "text-slate-500" }
const _hoisted_42 = { class: "text-dark-gradient col-span-2" }
const _hoisted_43 = { class: "text-slate-500" }
const _hoisted_44 = { class: "text-dark-gradient col-span-2" }
const _hoisted_45 = { class: "text-slate-500" }
const _hoisted_46 = { class: "text-dark-gradient col-span-2" }
const _hoisted_47 = { class: "text-slate-500" }
const _hoisted_48 = { class: "text-dark-gradient col-span-2" }
const _hoisted_49 = { class: "text-slate-500" }
const _hoisted_50 = { class: "text-dark-gradient col-span-2" }
const _hoisted_51 = { class: "col-span-3" }
const _hoisted_52 = {
  key: 1,
  class: "w-full px-4 mb-6 mt-0"
}
const _hoisted_53 = { class: "bg-white shadow-lg rounded-2xl flex flex-col h-full border border-slate-100" }
const _hoisted_54 = { class: "p-4 pb-0" }
const _hoisted_55 = { class: "text-lg font-bold text-slate-800 mb-0" }
const _hoisted_56 = { class: "p-4 flex flex-col" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { class: "w-full" }
const _hoisted_59 = {
  key: 2,
  class: "w-full px-4 mb-6 mt-0"
}
const _hoisted_60 = { class: "bg-white shadow-lg rounded-2xl flex flex-col h-full border border-slate-100" }
const _hoisted_61 = { class: "p-4 pb-0" }
const _hoisted_62 = { class: "text-lg font-bold text-slate-800 mb-0" }
const _hoisted_63 = { class: "p-4 flex flex-col" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "w-full" }
const _hoisted_66 = {
  key: 3,
  class: "w-full px-4 mb-6 mt-0"
}
const _hoisted_67 = { class: "bg-white shadow-lg rounded-2xl flex flex-col h-full border border-slate-100" }
const _hoisted_68 = { class: "p-4 pb-0" }
const _hoisted_69 = { class: "text-lg font-bold text-slate-800 mb-1" }
const _hoisted_70 = { class: "p-4 flex flex-col" }
const _hoisted_71 = { class: "divide-y divide-gray-200 list-none pb-4" }
const _hoisted_72 = { class: "flex items-center gap-3 py-2 mx-3" }
const _hoisted_73 = { class: "h-16 w-16 rounded-lg shadow-xl flex items-center justify-center border" }
const _hoisted_74 = { class: "flex-1 text-left" }
const _hoisted_75 = { class: "text-sm font-semibold text-gray-700 uppercase" }
const _hoisted_76 = { class: "text-sm font-semibold text-gray-700 uppercase" }
const _hoisted_77 = { class: "text-xs" }
const _hoisted_78 = { class: "relative" }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!
  const _component_EditarAcreditadoView = _resolveComponent("EditarAcreditadoView")!
  const _component_EditarEmpresaView = _resolveComponent("EditarEmpresaView")!
  const _component_EditarResumenEmpresaView = _resolveComponent("EditarResumenEmpresaView")!
  const _component_EditarResumenAcreditadoView = _resolveComponent("EditarResumenAcreditadoView")!
  const _component_CambiarPasswordView = _resolveComponent("CambiarPasswordView")!
  const _component_EnviarInvitacionView = _resolveComponent("EnviarInvitacionView")!
  const _component_ModalFileUpload = _resolveComponent("ModalFileUpload")!
  const _component_CropperView = _resolveComponent("CropperView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "mt-4 relative flex items-center justify-center min-h-[250px] rounded-xl overflow-hidden bg-cover bg-center",
        style: _normalizeStyle({ backgroundImage: 'url(' + require('@/assets/img/bkgPerfil.jpg') + ')', backgroundPositionY: '50%' })
      }, _cache[10] || (_cache[10] = [
        _createElementVNode("span", { class: "absolute inset-0 bg-green-600/60 mix-blend-multiply" }, null, -1)
      ]), 4),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.acreditado && _ctx.acreditado.foto ? _ctx.acreditado.foto : require('@/assets/img/nologo.png'),
                class: "shadow-md w-full h-full object-cover rounded-xl"
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.acreditado ? _ctx.acreditado.nombre + " " +
              _ctx.acreditado.apellido : _ctx.$t('label.cargando')), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('label.fecha.alta')) + " : " + _toDisplayString(_ctx.acreditado ?
              _ctx.formatDate(_ctx.acreditado.fechaAlta, 'dd/MM/yyyy HH:mm:ss') : _ctx.$t('label.cargando')), 1),
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.subirFotoPerfil && _ctx.subirFotoPerfil(...args))),
                  class: "text-xs text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-user-edit'] }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.subir.foto')), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mostrarCambiarPassword && _ctx.mostrarCambiarPassword(...args))),
                class: "px-3 text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'fa-key'],
                  class: "mr-2"
                }),
                _createTextVNode(_toDisplayString(_ctx.$t('boton.cambiar.password')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: _normalizeClass(["px-4 mb-6", [_ctx.usarPerfilEmpresas ? 'w-full lg:w-1/2' : 'w-full']])
        }, [
          _createElementVNode("div", _hoisted_15, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "p-4 pb-0" }, [
              _createElementVNode("h6", { class: "text-lg font-bold text-slate-800 mb-0" }, "Datos personales")
            ], -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('label.dni')), 1),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.acreditado ? _ctx.acreditado.dni : _ctx.$t('label.cargando')), 1),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('label.nombre')), 1),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.acreditado ? _ctx.acreditado.nombre : _ctx.$t('label.cargando')), 1),
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('label.apellido')), 1),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.acreditado ? _ctx.acreditado.apellido : _ctx.$t('label.cargando')), 1),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('label.cargo')), 1),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.acreditado ? _ctx.acreditado.cargo : _ctx.$t('label.cargando')), 1),
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('label.mail')), 1),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.acreditado ? _ctx.acreditado.mail : _ctx.$t('label.cargando')), 1),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('label.telefono')), 1),
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.acreditado ? _ctx.acreditado.telefono : _ctx.$t('label.cargando')), 1),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mostrarEdicionAcreditado && _ctx.mostrarEdicionAcreditado(...args))),
                  class: "text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer my-3"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-user-edit'] }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.modificar')), 1)
                ])
              ])
            ])
          ])
        ], 2),
        (_ctx.usarPerfilEmpresas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("img", {
                        src: (_ctx.empresa?.previewLogo) ? _ctx.empresa.previewLogo : require('@/assets/img/nologo.png'),
                        class: "shadow-md w-full h-full object-cover rounded-xl"
                      }, null, 8, _hoisted_35)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("h5", _hoisted_38, _toDisplayString(_ctx.empresa ? _ctx.empresa.nombreFantasia :
                  _ctx.$t('label.cargando')), 1),
                      (_ctx.empresa)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                            _createElementVNode("a", {
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.subirLogoEmpresa && _ctx.subirLogoEmpresa(...args))),
                              class: "text-xs text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer"
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-user-edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.subir.logo')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('label.razon.social')), 1),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.empresa ? _ctx.empresa.razonSocial : _ctx.$t('label.cargando')), 1),
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('label.cuit')), 1),
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.empresa ? _ctx.empresa.cuit : _ctx.$t('label.cargando')), 1),
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('label.pais')), 1),
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.empresa ? (_ctx.empresa?.pais?.descripcion ?? "") :
              _ctx.$t('label.cargando')), 1),
                  _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('label.pabellon')), 1),
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.empresa ? (_ctx.empresa?.pabellon ?? "") : _ctx.$t('label.cargando')), 1),
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('label.numero.stand')), 1),
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.empresa ? (_ctx.empresa?.stand ?? "") : _ctx.$t('label.cargando')), 1),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("a", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.mostrarEdicionEmpresa && _ctx.mostrarEdicionEmpresa(...args))),
                      class: "text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer my-3"
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', (_ctx.empresa && _ctx.empresa.id) ? 'fa-user-edit' : 'fa-plus']
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString((_ctx.empresa && _ctx.empresa.id) ? _ctx.$t('boton.modificar') : _ctx.$t('boton.crear.mi.empresa')), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.cargarResumenAcreditado)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("h6", _hoisted_55, _toDisplayString(_ctx.$t('label.resumen.acreditado')), 1)
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", {
                    class: "text-xs md:text-sm [&>p]:mb-2 [&>p:empty]:h-2",
                    innerHTML: _ctx.acreditado ? (_ctx.resumenAcreditado ? _ctx.resumenAcreditado : _ctx.$t('label.no.cargo.resumen.acreditado')) : _ctx.$t('label.cargando')
                  }, null, 8, _hoisted_57),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("a", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.mostrarEdicionResumenAcreditado && _ctx.mostrarEdicionResumenAcreditado(...args))),
                      class: "text-sm text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer my-3"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-user-edit'] }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.modificar')), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.usarPerfilEmpresas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("h6", _hoisted_62, _toDisplayString(_ctx.$t('label.resumen.empresa')), 1)
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", {
                    class: "text-xs md:text-sm [&>p]:mb-2 [&>p:empty]:h-2",
                    innerHTML: _ctx.empresa ? (_ctx.empresa.breveDescripcion ? _ctx.empresa.breveDescripcion : _ctx.$t('label.no.cargo.empresa')) : _ctx.$t('label.cargando')
                  }, null, 8, _hoisted_64),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("a", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.mostrarEdicionResumenEmpresa && _ctx.mostrarEdicionResumenEmpresa(...args))),
                      class: "text-sm text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer my-3"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-user-edit'] }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.modificar')), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.usarPerfilEmpresas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("h6", _hoisted_69, _toDisplayString(_ctx.$t('label.acreditados.empresa')), 1)
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("ul", _hoisted_71, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.acreditadosEmpresa, (item, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['fas', 'fa-user'],
                              class: _normalizeClass(["text-2xl", item.administradorEmpresa ? 'text-green-700' : 'text-gray-500'])
                            }, null, 8, ["class"])
                          ]),
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, _toDisplayString(item.nombre), 1),
                            _createElementVNode("div", _hoisted_76, _toDisplayString(item.apellido), 1),
                            _createElementVNode("div", _hoisted_77, _toDisplayString(item.mail), 1)
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            (_ctx.esAdministrador() && !item.administradorEmpresa)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.preguntaCambiarAdministrador(item))
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: ['fas', 'fa-user-tie'],
                                    class: "text-2xl mr-2 text-gray-500 hover:text-green-700 cursor-pointer"
                                  })
                                ], 8, _hoisted_79))
                              : _createCommentVNode("", true),
                            (!item.administradorEmpresa)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.preguntaDesasociarUsuario(item))
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: ['far', 'fa-trash-can'],
                                    class: "text-2xl mr-2 text-gray-500 hover:text-red-600 cursor-pointer"
                                  })
                                ], 8, _hoisted_80))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.invitarUsuarioEmpresa && _ctx.invitarUsuarioEmpresa(...args))),
                      class: "px-5 text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['far', 'fa-paper-plane'],
                        class: "mr-2"
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t('boton.invitar.usuario')), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"]),
    (_ctx.editarAcreditadoVisible)
      ? (_openBlock(), _createBlock(_component_EditarAcreditadoView, {
          key: 0,
          closeFunction: _ctx.closeDialogAcreditado
        }, null, 8, ["closeFunction"]))
      : _createCommentVNode("", true),
    (_ctx.editarEmpresaVisible)
      ? (_openBlock(), _createBlock(_component_EditarEmpresaView, {
          key: 1,
          closeFunction: _ctx.closeDialogEmpresa
        }, null, 8, ["closeFunction"]))
      : _createCommentVNode("", true),
    (_ctx.editarResumenEmpresaVisible)
      ? (_openBlock(), _createBlock(_component_EditarResumenEmpresaView, {
          key: 2,
          closeFunction: _ctx.closeDialogResumenEmpresa
        }, null, 8, ["closeFunction"]))
      : _createCommentVNode("", true),
    (_ctx.editarResumenAcreditadoVisible)
      ? (_openBlock(), _createBlock(_component_EditarResumenAcreditadoView, {
          key: 3,
          closeFunction: _ctx.closeDialogResumenAcreditado
        }, null, 8, ["closeFunction"]))
      : _createCommentVNode("", true),
    (_ctx.cambiarPasswordVisible)
      ? (_openBlock(), _createBlock(_component_CambiarPasswordView, {
          key: 4,
          closeFunction: _ctx.closeDialogCambiarPassword
        }, null, 8, ["closeFunction"]))
      : _createCommentVNode("", true),
    (_ctx.enviarInvitacionVisible)
      ? (_openBlock(), _createBlock(_component_EnviarInvitacionView, {
          key: 5,
          empresa: _ctx.empresa,
          closeFunction: _ctx.closeDialogEnviarInvitacion
        }, null, 8, ["empresa", "closeFunction"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalFileUpload, {
      visible: _ctx.isFileUploadVisible,
      askDescription: false,
      forceSquare: false,
      maxSizeMB: 2,
      fileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
      onAccept: _ctx.onFileUploadAcepted,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isFileUploadVisible = $event))
    }, null, 8, ["visible", "onAccept"]),
    _createVNode(_component_ModalFileUpload, {
      visible: _ctx.isLogoFileUploadVisible,
      askDescription: false,
      forceSquare: false,
      maxSizeMB: 2,
      fileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
      onAccept: _ctx.onLogoFileUploadAcepted,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isLogoFileUploadVisible = $event))
    }, null, 8, ["visible", "onAccept"]),
    (_ctx.showCropper)
      ? (_openBlock(), _createBlock(_component_CropperView, {
          key: 6,
          image: _ctx.beforeCropBase64,
          onClose: _ctx.onCropFinished
        }, null, 8, ["image", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.logoShowCropper)
      ? (_openBlock(), _createBlock(_component_CropperView, {
          key: 7,
          image: _ctx.logoBeforeCropBase64,
          onClose: _ctx.onLogoCropFinished
        }, null, 8, ["image", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}